export default {
  authorizedRedirections: [
    /^\/$/,
    /^\/publish/,
    /^\/login/,
    /^\/explorer/,
    /^\/portal/,   
    /^\/maps/,
    /^\/oidc/,
  ],
  idp: {
    host: "https://safie-geospatial.fr/login"
  },
  client: {
    name: "Neogeo",
    email: "contact@neogeo.fr"
  },
  forms: {
    signin: {
      title: {
        en: "Enter your login",
        fr: "Saisissez vos identifiants",
      }
    },
    signup: {
      disabled: true,
      hiddenFields: [],
      requiredFields: [
        'first_name',
        'last_name',
        'email',
      ],
    },
    organisation: {
      hiddenFields: [],
      requiredFields: [
        'name',
        'type',
      ],
    },
  }
};
